<template>
  <a :href="$websitePath(path)">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "AppWebsiteLink",
  props: {
    path: {
      type: String,
      required: true,
    },
  },
};
</script>
